import { jsx as _jsx } from "react/jsx-runtime";
import { Button, CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { useFormContext, useFormState } from "react-hook-form";
export const FormButton = ({ children, triggerValidation = false, ...props })=>{
    const formContext = useFormContext();
    const formState = useFormState();
    /* react-hook-form treats an untouched form as invalid, so validate on mount.
     Deferred a tick: this child effect runs before the parent form's `values`
     reset, and an immediate trigger would validate the pre-reset values and
     land its errors after the reset already cleared them */ useEffect(()=>{
        if (!triggerValidation) return;
        const timer = setTimeout(()=>formContext.trigger());
        return ()=>clearTimeout(timer);
    }, [
        triggerValidation
    ]);
    const isValid = formState.isValid || formContext.formState.isValid;
    const isDisabled = props.disabled || formState.isSubmitting || !isValid;
    return /*#__PURE__*/ _jsx(Button, {
        ...props,
        "data-testid": props['data-testid'] || 'submit',
        disabled: isDisabled,
        endIcon: formState.isSubmitting ? /*#__PURE__*/ _jsx(CircularProgress, {
            size: 20
        }) : props.endIcon,
        type: "submit",
        children: children
    });
};
FormButton.displayName = 'FormButton';

//# sourceMappingURL=FormButton.js.map